import { isUuid } from '../marketplace/helpers/useSearchQueries';

/** First value of a possibly-repeated (`?k=a&k=b`) query param. */
export const pickString = (value: string | string[] | undefined): string | undefined =>
  Array.isArray(value) ? value[0] : value;

/**
 * Narrows the `?config=` query param to the AccountFormPage config union with a
 * value check rather than an unchecked cast, so an arbitrary query string can
 * never masquerade as the domain literal.
 */
export const pickAccountFormConfig = (
  value: string | string[] | undefined,
): 'resaleClosingDashboard' | undefined =>
  pickString(value) === 'resaleClosingDashboard' ? 'resaleClosingDashboard' : undefined;

const likedIdFrom = (value: string): string | undefined => {
  try {
    const likedId = new URL(value, 'https://www.opendoor.com').searchParams.get('likedId');
    return likedId && isUuid(likedId) ? likedId : undefined;
  } catch {
    return undefined;
  }
};

/**
 * Address UUID of the listing whose favorite soft-gate sent the user to
 * `/login?redirectTo=...&likedId=<uuid>...`. The `likedId` param rides inside
 * `redirectTo`, which may arrive URL-encoded, so an encoded value gets one
 * decode-and-retry. Organic sign-ins have no listing context and resolve to
 * `undefined`.
 */
export const pickLikedAddressUuid = (redirectTo: string | undefined): string | undefined => {
  if (!redirectTo) {
    return undefined;
  }
  const direct = likedIdFrom(redirectTo);
  if (direct) {
    return direct;
  }
  try {
    return likedIdFrom(decodeURIComponent(redirectTo));
  } catch {
    return undefined;
  }
};
